import { Helmet } from "react-helmet-async";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import HowItWorks from "@/components/landing/HowItWorks";
import Testimonials from "@/components/landing/Testimonials";
import Industries from "@/components/landing/Industries";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>
          Wolf CTO | Expand Margins With AI for $5M+ Businesses
        </title>
        <meta
          name="description"
          content="AI systems that cut costs and lift revenue for $5M+ businesses. We identify $50K+ in annual savings or you don't pay. We build, you own."
        />
        <meta
          name="keywords"
          content="AI operations, AI automation, margin expansion, cost reduction, revenue lift, AI for business, AI consulting"
        />
        <link rel="canonical" href="https://wolf-cto.com" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Wolf CTO | Expand Margins With AI for $5M+ Businesses"
        />
        <meta
          property="og:description"
          content="AI systems that cut costs and lift revenue for $5M+ businesses. We identify $50K+ in annual savings or you don't pay. We build, you own."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://wolf-cto.com" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Wolf CTO | Expand Margins With AI for $5M+ Businesses"
        />
        <meta
          name="twitter:description"
          content="AI systems that cut costs and lift revenue for $5M+ businesses. We identify $50K+ in annual savings or you don't pay. We build, you own."
        />
      </Helmet>

      <main className="min-h-screen">
        <Header />
        <Hero />
        <HowItWorks />
        <Testimonials />
        <Industries />
        <FAQ />
        <Footer />
      </main>
    </>
  );
};

export default Index;
